import React, {Component} from 'react';
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";

class ImageBox extends Component {
    constructor(props) {
        super(props);
        this.state={
            base64:''
        }
        this.fetchData = this.fetchData.bind(this);
        this.download = this.download.bind(this);
    }

    componentDidMount(){
        this.fetchData(this.props.path)
    }

    fetchData(path){
        let self = this;

        let params={
            url: '/requestForm/getImage?path=' + path,
            method: "get",
        }
        request(params).then(function (response) {
            self.setState({base64:response.data})
        }).catch(function (error) {

            showAxiosError(error);
        });
    }

    download(path){
        let params = {
            url: `/requestForm/downloadImage?path=`+ path,
            responseType: 'arraybuffer',
            method: "get",

        };
        request(params)
            .then(function (response) {
                let blob = new Blob([response.data], {type: response.headers["content-type"]});
                let urlCreator = window.URL || window.webkitURL;
                let url = urlCreator.createObjectURL(blob);

                    let a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = "downloadedimage" +  ".jpeg";
                    a.click();

            }).catch(function (error) {
            if (error.response === undefined) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
            } else {
                let enc = new TextDecoder("utf-8");
                showAxiosError({message: enc.decode(error.response.data)});
            }

        });
    }

    render() {
        return (
            <div className="image">
                <button className="download-button" onClick={()=>this.download(this.props.path)}>
                    <i className="far fa-arrow-alt-circle-down"/>
                </button>
                <img style={{width:"200px"}} src={`data:image/jpeg;base64,${this.state.base64}`}></img>
            </div>
        );
    }
}

export default ImageBox;